import { render, staticRenderFns } from "./TermsCstmrRegByCstmr.vue?vue&type=template&id=297d9d53&"
import script from "./TermsCstmrRegByCstmr.vue?vue&type=script&lang=js&"
export * from "./TermsCstmrRegByCstmr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports